module.exports = "../../../../platform/assets/pageMainIcon/business_yewushezhilei8.svg";